import Tobii from "../../../node_modules/tobii/dist/js/tobii";

try {
    const tobii = new Tobii()
} catch (err) {

}
